module.exports = __webpack_public_path__ + "img/page11.45978ddd.png";